import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import ThanksButton from "./thanks_button";

export default createReactClass({
  displayName: "Root",
  PropTypes: {
    circleId: PropTypes.number.isRequired,
  },
  getInitialState() {
    return {
      thanksTargetUsers: [],
      isThanksTargetUsersEnabled: {},
      isThanksButtonEnable: false,
    };
  },
  componentDidMount() {
    this.loadThanksTargetDataFromServer();
  },
  loadThanksTargetDataFromServer() {
    $.ajax({
      url: "/api/thank/circle",
      dataType: "json",
      cache: false,
      data: {
        circle_id: this.props.circleId,
      },
      success: function(data) {
        this.setState({
          thanksTargetUsers: data.thanksTargetUsers,
          isThanksTargetUsersEnabled: data.isThanksTargetUsersEnabled,
          isThanksButtonEnable: data.isThanksButtonEnable,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  render() {
    if (!this.state.isThanksButtonEnable) {
      return <div />;
    }
    return (
      <div>
        <ThanksButton
          thanksTargetUsers={this.state.thanksTargetUsers}
          isThanksTargetUsersEnabled={this.state.isThanksTargetUsersEnabled}
          circleId={this.props.circleId}
        />
      </div>
    );
  },
});
